// import React, { useEffect, useRef, useState } from "react";
// import { IoIosSearch } from "react-icons/io";


// const Filtering = ({
//   availableFilters = {},
//   currentFilters = {},
//   onFiltersChange = undefined,
//   searchTerm = "",
//   onSearchChange = undefined,
//   onResetPeriod = () => {},
//   showPeriodToggle = false,
//   showSearch = false,
//   activePeriod = undefined,
//   onPeriodChange = undefined,
//    disabled = false,
// }) => {
//   const normalize = (v) => (v === undefined || v === null ? "" : String(v).trim());

//   const getFilterNamesFromAvailable = (av) => [
//     ...(av?.name ?? []),
//     ...(av?.rulePhase ? ["rulePhase"] : []),
//   ];

//   const getOptionsFor = (f, av = availableFilters) =>
//     f === "rulePhase" ? av?.rulePhase ?? [] : av?.list?.[f] ?? [];

//   const [localFilters, setLocalFilters] = useState(() => {
//     const init = {};
//     (currentFilters && typeof currentFilters === "object") &&
//       Object.keys(currentFilters).forEach((k) => (init[k] = normalize(currentFilters[k])));
//     return init;
//   });

//   // flag indicating user interacted in this instance OR parent gave a selection
//   const userInteractedRef = useRef(false);

//   const equalFilters = (a = {}, b = {}) => {
//     const keys = new Set([...Object.keys(a || {}), ...Object.keys(b || {})]);
//     for (const k of keys) {
//       if (normalize(a[k]) !== normalize(b[k])) return false;
//     }
//     return true;
//   };

//   const hasAnyCurrentFilter = (cf = currentFilters) => {
//     if (!cf || typeof cf !== "object") return false;
//     return Object.keys(cf).some((k) => normalize(cf[k]) !== "");
//   };

//   // INITIALIZER: ensure keys exist for all filters when availableFilters arrives (no auto-select)
//   useEffect(() => {
//     if (!availableFilters) return;
//     const names = getFilterNamesFromAvailable(availableFilters);
//     setLocalFilters((prev) => {
//       const init = { ...prev };
//       names.forEach((f) => {
//         if (init[f] === undefined) init[f] = normalize(currentFilters?.[f] ?? "");
//       });
//       return init;
//     });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [availableFilters]);

//   // SYNC: when parent passes currentFilters (e.g., switching tabs), update localFilters to match
//   useEffect(() => {
//     const incoming = {};
//     (currentFilters && typeof currentFilters === "object") &&
//       Object.keys(currentFilters).forEach((k) => (incoming[k] = normalize(currentFilters[k])));

//     const names = getFilterNamesFromAvailable(availableFilters);
//     names.forEach((f) => {
//       if (incoming[f] === undefined) incoming[f] = "";
//     });

//     if (!equalFilters(localFilters, incoming)) {
//       setLocalFilters(incoming);
//       // mark userInteracted if incoming has any non-empty selection (this treats parent selection like user interaction)
//       userInteractedRef.current = hasAnyCurrentFilter(incoming);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [currentFilters, availableFilters]);

//   // After user interaction OR parent-provided selection, when availableFilters updates (server narrowed lists),
//   // set any server-narrowed single options into localFilters if currently empty
//   useEffect(() => {
//     if (!availableFilters) return;
//     // run if user interacted in this instance OR parent already had a selection
//     if (!userInteractedRef.current && !hasAnyCurrentFilter()) return;

//     setLocalFilters((prev) => {
//       const next = { ...prev };
//       let changed = false;
//       const names = getFilterNamesFromAvailable(availableFilters);

//       names.forEach((f) => {
//         const opts = getOptionsFor(f).map(normalize);
//         const currently = normalize(next[f]);
//         if ((currently === "" || currently === undefined) && opts.length === 1) {
//           next[f] = opts[0];
//           changed = true;
//         }
//       });

//       return changed ? next : prev;
//     });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [availableFilters]);

//   // When user selects a filter
//   const handleSelectChange = (name, value) => {
//     userInteractedRef.current = true;
//     const normalizedValue = normalize(value);

//     setLocalFilters((prev) => {
//       const next = { ...prev, [name]: normalizedValue };

//       // autopopulate other filters client-side if empty and have exactly 1 option
//       const names = getFilterNamesFromAvailable(availableFilters);
//       names.forEach((f) => {
//         if (f === name) return;
//         const currentlySet = normalize(next[f]);
//         const opts = getOptionsFor(f).map(normalize);
//         if ((currentlySet === "" || currentlySet === undefined) && opts.length === 1) {
//           next[f] = opts[0];
//         }
//       });

//       onFiltersChange && onFiltersChange(next);
//       return next;
//     });
//   };

//   const handleReset = () => {
//     const names = getFilterNamesFromAvailable(availableFilters);
//     const cleared = {};
//     names.forEach((f) => (cleared[f] = ""));
//     setLocalFilters(cleared);
//     userInteractedRef.current = false;
//     onFiltersChange && onFiltersChange({});
//     onSearchChange && onSearchChange("");
//     onResetPeriod && onResetPeriod();
//   };

//   const renderSelect = (filterName, options = []) => {
//     const selectedVal = normalize(localFilters?.[filterName]);
//     const normOptions = (options || []).map(normalize);

//     return (
//       <select
//         value={selectedVal}
//         onChange={(e) => handleSelectChange(filterName, e.target.value)}
//         disabled={disabled}
//         className="border border-gray-300 rounded px-2 py-1"
//       >
//         <option value="">All</option>

//         {options.map((opt, idx) => (
//           <option key={idx} value={normalize(opt)}>
//             {opt}
//           </option>
//         ))}

//         {selectedVal && !normOptions.includes(selectedVal) && (
//           <option key={`__sel__${filterName}`} value={selectedVal}>
//             {selectedVal}
//           </option>
//         )}
//       </select>
//     );
//   };

//   return (
//     <div
//       className="filters-search-panel grid gap-5 mb-8"
//       style={{ gridTemplateColumns: "repeat(auto-fit, minmax(130px, 130px))" }}
//     >
//       {availableFilters?.name?.map((filterName) => (
//         <div key={filterName} className="filter-items flex flex-col">
//           <label className="mb-1">{filterName}</label>
//           {renderSelect(filterName, availableFilters?.list?.[filterName] ?? [])}
//         </div>
//       ))}

//       {availableFilters?.rulePhase && (
//         <div className="filter-items flex flex-col">
//           <label className="mb-1">Rule Phase</label>
//           {renderSelect("rulePhase", availableFilters.rulePhase ,disabled)}
//         </div>
//       )}

//       {showSearch && (
//         <div className="flex items-center bg-white border border-gray-300 rounded px-3 mt-[25px]" style={{ height: "41px" }}>
//           <input
//             type="text"
//             placeholder="Search Rules"
//             value={searchTerm}
//             onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
//             className="flex-1 outline-none bg-transparent"
//             disabled={disabled}
//           />
//           <IoIosSearch className="text-gray-500" />
//         </div>
//       )}

//       {showPeriodToggle && (
//         <div className="period-toggling flex gap-2 mt-[27px]">
//         <button
//   className={`curnt-period ${activePeriod === "Current" ? "active" : ""}`}
//   onClick={() => onPeriodChange && onPeriodChange("current")}
// >
//   Current Period
// </button>

// <button
//   className={`curnt-period ${activePeriod === "Previous" ? "active" : ""}`}
//   onClick={() => onPeriodChange && onPeriodChange("last")}
// >
//   Last Period
// </button>


//         </div>
//       )}

//       <div className="flex justify-end mt-[25px]">
//         <button onClick={handleReset} className="flex items-center gap-2 px-5 py-3 text-gray-700 bg-white border border-gray-300 rounded h-[40px] w-[100px]" disabled={disabled}>
//           Reset
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Filtering;
import React, { useEffect, useRef, useState } from "react";
import { IoIosSearch } from "react-icons/io";
import { FormControl, Select, MenuItem } from "@mui/material";



const Filtering = ({
  availableFilters = {},
  currentFilters = {},
  onFiltersChange = undefined,
  searchTerm = "",
  onSearchChange = undefined,
  onResetPeriod = () => {},
  showPeriodToggle = false,
  showSearch = false,
  activePeriod = undefined,
  onPeriodChange = undefined,
   disabled = false,
}) => {
  const normalize = (v) => (v === undefined || v === null ? "" : String(v).trim());

  const getFilterNamesFromAvailable = (av) => [
    ...(av?.name ?? []),
    ...(av?.rulePhase ? ["rulePhase"] : []),
  ];

  const getOptionsFor = (f, av = availableFilters) =>
    f === "rulePhase" ? av?.rulePhase ?? [] : av?.list?.[f] ?? [];

  const [localFilters, setLocalFilters] = useState(() => {
    const init = {};
    (currentFilters && typeof currentFilters === "object") &&
      Object.keys(currentFilters).forEach((k) => (init[k] = normalize(currentFilters[k])));
    return init;
  });

  // flag indicating user interacted in this instance OR parent gave a selection
  const userInteractedRef = useRef(false);

  const equalFilters = (a = {}, b = {}) => {
    const keys = new Set([...Object.keys(a || {}), ...Object.keys(b || {})]);
    for (const k of keys) {
      if (normalize(a[k]) !== normalize(b[k])) return false;
    }
    return true;
  };

  const hasAnyCurrentFilter = (cf = currentFilters) => {
    if (!cf || typeof cf !== "object") return false;
    return Object.keys(cf).some((k) => normalize(cf[k]) !== "");
  };

  // INITIALIZER: ensure keys exist for all filters when availableFilters arrives (no auto-select)
  useEffect(() => {
    if (!availableFilters) return;
    const names = getFilterNamesFromAvailable(availableFilters);
    setLocalFilters((prev) => {
      const init = { ...prev };
      names.forEach((f) => {
        if (init[f] === undefined) init[f] = normalize(currentFilters?.[f] ?? "");
      });
      return init;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableFilters]);

  // SYNC: when parent passes currentFilters (e.g., switching tabs), update localFilters to match
  useEffect(() => {
    const incoming = {};
    (currentFilters && typeof currentFilters === "object") &&
      Object.keys(currentFilters).forEach((k) => (incoming[k] = normalize(currentFilters[k])));

    const names = getFilterNamesFromAvailable(availableFilters);
    names.forEach((f) => {
      if (incoming[f] === undefined) incoming[f] = "";
    });

    if (!equalFilters(localFilters, incoming)) {
      setLocalFilters(incoming);
      // mark userInteracted if incoming has any non-empty selection (this treats parent selection like user interaction)
      userInteractedRef.current = hasAnyCurrentFilter(incoming);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFilters, availableFilters]);

  // After user interaction OR parent-provided selection, when availableFilters updates (server narrowed lists),
  // set any server-narrowed single options into localFilters if currently empty
  useEffect(() => {
    if (!availableFilters) return;
    // run if user interacted in this instance OR parent already had a selection
    if (!userInteractedRef.current && !hasAnyCurrentFilter()) return;

    setLocalFilters((prev) => {
      const next = { ...prev };
      let changed = false;
      const names = getFilterNamesFromAvailable(availableFilters);

      names.forEach((f) => {
        const opts = getOptionsFor(f).map(normalize);
        const currently = normalize(next[f]);
        if ((currently === "" || currently === undefined) && opts.length === 1) {
          next[f] = opts[0];
          changed = true;
        }
      });

      return changed ? next : prev;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableFilters]);

  // When user selects a filter
  const handleSelectChange = (name, value) => {
    userInteractedRef.current = true;
    const normalizedValue = normalize(value);

    setLocalFilters((prev) => {
      const next = { ...prev, [name]: normalizedValue };

      // autopopulate other filters client-side if empty and have exactly 1 option
      const names = getFilterNamesFromAvailable(availableFilters);
      names.forEach((f) => {
        if (f === name) return;
        const currentlySet = normalize(next[f]);
        const opts = getOptionsFor(f).map(normalize);
        if ((currentlySet === "" || currentlySet === undefined) && opts.length === 1) {
          next[f] = opts[0];
        }
      });

      onFiltersChange && onFiltersChange(next);
      return next;
    });
  };

  const handleReset = () => {
    const names = getFilterNamesFromAvailable(availableFilters);
    const cleared = {};
    names.forEach((f) => (cleared[f] = ""));
    setLocalFilters(cleared);
    userInteractedRef.current = false;
    onFiltersChange && onFiltersChange({});
    onSearchChange && onSearchChange("");
    onResetPeriod && onResetPeriod();
  };

  // const renderSelect = (filterName, options = []) => {
  //   const selectedVal = normalize(localFilters?.[filterName]);
  //   const normOptions = (options || []).map(normalize);

  //   return (
  //     <select
  //       value={selectedVal}
  //       onChange={(e) => handleSelectChange(filterName, e.target.value)}
  //       disabled={disabled}
  //       className="border border-gray-300 rounded px-2 py-1"
  //     >
  //       <option value="">All</option>

  //       {options.map((opt, idx) => (
  //         <option key={idx} value={normalize(opt)}>
  //           {opt}
  //         </option>
  //       ))}

  //       {selectedVal && !normOptions.includes(selectedVal) && (
  //         <option key={`__sel__${filterName}`} value={selectedVal}>
  //           {selectedVal}
  //         </option>
  //       )}
  //     </select>
  //   );
  // };

  const renderSelect = (filterName, options = []) => {
  const selectedVal = normalize(localFilters?.[filterName]);
  const normOptions = (options || []).map(normalize);

  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: 150, // dropdown menu scroll height
        overflowY: "auto",
      },
    },
  };

  return (
    <FormControl fullWidth size="small">
      <Select
        value={selectedVal || ""}
        onChange={(e) => handleSelectChange(filterName, e.target.value)}
        displayEmpty
        disabled={disabled}
        className="border border-gray-300 rounded px-2 py-1"
        MenuProps={menuProps}
       sx={{
  height: "40px",
  backgroundColor: "#fff",
  border: "1px solid #E8E8EB",        
  borderRadius: "4px",
  color: "#747474",
  fontFamily: "Poppins, sans-serif",
  fontSize: "14px",
  "& .MuiSelect-select": {
    paddingY: "4px",
    paddingX: "10px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",                    
  },
  "&:hover": {
    border: "1px solid #E8E8EB",       
  },
  "&.Mui-focused": {
    border: "1px solid #E8E8EB",        
    boxShadow: "none",
  },
}}

        renderValue={(selected) => (selected ? selected : "All")}
      >
        <MenuItem value="">All</MenuItem>

        {options.map((opt, idx) => (
          <MenuItem key={idx} value={normalize(opt)}>
            {opt}
          </MenuItem>
        ))}

        {selectedVal && !normOptions.includes(selectedVal) && (
          <MenuItem key={`__sel__${filterName}`} value={selectedVal}>
            {selectedVal}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

  return (
//     <div
//       className="filters-search-panel grid gap-5 mb-8"
//       style={{ gridTemplateColumns: "repeat(auto-fit, minmax(130px, 130px))" }}
//     >
//       {availableFilters?.name?.map((filterName) => (
//         <div key={filterName} className="filter-items flex flex-col">
//           <label className="mb-1">{filterName}</label>
//           {renderSelect(filterName, availableFilters?.list?.[filterName] ?? [])}
//         </div>
//       ))}

//       {availableFilters?.rulePhase && (
//         <div className="filter-items flex flex-col">
//           <label className="mb-1">Rule Phase</label>
//           {renderSelect("rulePhase", availableFilters.rulePhase ,disabled)}
//         </div>
//       )}

//       {showSearch && (
//         <div className="flex items-center bg-white border border-gray-300 rounded px-3 mt-[25px]" style={{ height: "41px" }}>
//           <input
//             type="text"
//             placeholder="Search Rules"
//             value={searchTerm}
//             onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
//             className="flex-1 outline-none bg-transparent"
//             disabled={disabled}
//           />
//           <IoIosSearch className="text-gray-500" />
//         </div>
//       )}

//       {showPeriodToggle && (
//         <div className="period-toggling flex gap-2 mt-[27px]">
//         <button
//   className={`curnt-period ${activePeriod === "Current" ? "active" : ""}`}
//   onClick={() => onPeriodChange && onPeriodChange("current")}
// >
//   Current Period
// </button>

// <button
//   className={`curnt-period ${activePeriod === "Previous" ? "active" : ""}`}
//   onClick={() => onPeriodChange && onPeriodChange("last")}
// >
//   Last Period
// </button>


//         </div>
//       )}

//       <div className="flex justify-end  mt-[25px]">
//       <button
//   onClick={handleReset}
//   className="flex justify-center items-center px-5 py-3 text-gray-700 bg-white border border-gray-300 rounded h-[40px] w-[70px]"
//   disabled={disabled}
// >
//   Reset
// </button>
//       </div>
//     </div>
<div className="flex items-start justify-between gap-4 mb-8">
  <div
    className="filters-search-panel grid gap-5 flex-1"
    style={{ gridTemplateColumns: "repeat(auto-fit, minmax(130px, 130px))" }}
  >
    {availableFilters?.name?.map((filterName) => (
      <div key={filterName} className="filter-items flex flex-col">
        <label className="mb-1">{filterName}</label>
        {renderSelect(filterName, availableFilters?.list?.[filterName] ?? [])}
      </div>
    ))}

    {availableFilters?.rulePhase && (
      <div className="filter-items flex flex-col">
        <label className="mb-1">Rule Phase</label>
        {renderSelect("rulePhase", availableFilters.rulePhase ,disabled)}
      </div>
    )}

    {/* {showSearch && (
      <div className="flex items-center bg-white border border-gray-300 rounded px-3 mt-[25px]" style={{ height: "41px",width:'160px' }}>
        <input
          type="text"
          placeholder="Search Rules"
          value={searchTerm}
          onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
          className="flex-1 outline-none bg-transparent"
          disabled={disabled}
        />
        <IoIosSearch className="text-gray-500" />
      </div>
    )} */}

    {showPeriodToggle && (
      <div className="period-toggling flex gap-2 mt-[27px]">
        <button
          className={`curnt-period ${activePeriod === "Current" ? "active" : ""}`}
          onClick={() => onPeriodChange && onPeriodChange("current")}
        >
          Current Period
        </button>

        <button
          className={`curnt-period ${activePeriod === "Previous" ? "active" : ""}`}
          onClick={() => onPeriodChange && onPeriodChange("last")}
        >
          Last Period
        </button>
      </div>
    )}
  </div>

  {/* <div className="flex items-start">
    <button
      onClick={handleReset}
      className="flex justify-center items-center px-5 py-3 text-gray-700 bg-white border border-gray-300 rounded h-[40px] w-[70px]"
      disabled={disabled}
    >
      Reset
    </button>
  </div> */}
  {/* RIGHT: Reset button pinned to the right and aligned with left controls */}
<div className="flex items-start self-start mt-[47px]">
  <button
    onClick={handleReset}
    className="flex justify-center items-center px-5 py-3 text-gray-700 bg-white border border-gray-300 rounded h-[40px] w-[70px]"
    disabled={disabled}
  >
    Reset
  </button>
</div>

</div>

  );
};

export default Filtering;
